import React from 'react'

const Premium = () => {
  return (
    <div>Premium</div>
  )
}

export default Premium